export default __webpack_public_path__ + "static/media/twitter.bc404739.svg";